module.exports = __webpack_public_path__ + "static/media/alert-system-notification.c5eff074.mp3";